// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"146067d7","419":"2a021728","563":"bf5f5d8d","787":"d25871fa","942":"16aa0a19"}[chunkId] + ".chunk.js";
};